import { on } from "@ngrx/store";
import { VendorInquiriesActions } from "./vendor-inquiries.actions";
import { PagesStore } from "../../pages.state";

const loadVendorInquirySummariesSuccess = on(
    VendorInquiriesActions.loadVendorInquirySummariesSuccess,
    (state: PagesStore, { summaries }) => ({
        ...state,
        quote: {
            ...state.quote,
            vendorInquiries: summaries.map(summary => ({ summary, inquiry: null, result: null })),
        },
    }),
);

const generateVendorInquiriesSuccess = on(
    VendorInquiriesActions.generateVendorInquiriesSuccess,
    (state: PagesStore, { vendorInquiries }) => ({
        ...state,
        quote: {
            ...state.quote,
            vendorInquiries: state.quote.vendorInquiries.map(vi => {
                const updated = vendorInquiries.find(v => v.brandCode === vi.summary?.brandCode && v.versionId === vi.summary?.versionId);
                return updated ? { ...vi, inquiry: updated } : vi;
            }),
        },
    }),
);

const sendVendorInquiriesSuccess = on(
    VendorInquiriesActions.sendVendorInquiriesSuccess,
    (state: PagesStore, { results }) => ({
        ...state,
        quote: {
            ...state.quote,
            vendorInquiries: state.quote.vendorInquiries.map(vi => {
                const result = results.find(r => r.brandName === vi.summary?.brandName);
                return result ? { ...vi, result } : vi;
            }),
        },
    }),
);

const selectVendorInquiriesForSending = on(
    VendorInquiriesActions.selectVendorInquiriesForSending,
    (state: PagesStore, { vendorInquiries }) => ({
        ...state,
        quote: {
            ...state.quote,
            vendorInquiries: state.quote.vendorInquiries.map(vi => {
                const selected = vendorInquiries.find(v => v.brandCode === vi.summary?.brandCode && v.versionId === vi.summary?.versionId);
                return selected ? { ...vi, inquiry: selected } : { ...vi, inquiry: null };
            }),
        },
    }),
);

const updateVendorInquiryCCEmails = on(
    VendorInquiriesActions.updateVendorInquiryCCEmails,
    (state: PagesStore, { brandCode, versionId, ccEmails }) => ({
        ...state,
        quote: {
            ...state.quote,
            vendorInquiries: state.quote.vendorInquiries.map(vi =>
                vi.summary?.brandCode === brandCode && vi.summary?.versionId === versionId
                    ? { ...vi, inquiry: vi.inquiry ? { ...vi.inquiry, ccEmails } : null }
                    : vi
            ),
        },
    }),
);

const updateVendorInquiryMessage = on(
    VendorInquiriesActions.updateVendorInquiryMessage,
    (state: PagesStore, { brandCode, versionId, message }) => ({
        ...state,
        quote: {
            ...state.quote,
            vendorInquiries: state.quote.vendorInquiries.map(vi =>
                vi.summary?.brandCode === brandCode && vi.summary?.versionId === versionId
                    ? { ...vi, inquiry: vi.inquiry ? { ...vi.inquiry, message } : null }
                    : vi
            ),
        },
    }),
);

const updateVendorInquiryFileIds = on(
    VendorInquiriesActions.updateVendorInquiryFileIds,
    (state: PagesStore, { brandCode, versionId, fileIds }) => ({
        ...state,
        quote: {
            ...state.quote,
            vendorInquiries: state.quote.vendorInquiries.map(vi =>
                vi.summary?.brandCode === brandCode && vi.summary?.versionId === versionId
                    ? { ...vi, inquiry: vi.inquiry ? { ...vi.inquiry, fileIds } : null }
                    : vi
            ),
        },
    }),
);

const clearVendorInquiry = on(
    VendorInquiriesActions.clearVendorInquiry,
    (state: PagesStore, { brandCode, versionId }) => ({
        ...state,
        quote: {
            ...state.quote,
            vendorInquiries: state.quote.vendorInquiries.map(vi =>
                vi.summary?.brandCode === brandCode && vi.summary?.versionId === versionId
                    ? { ...vi, inquiry: null }
                    : vi
            ),
        },
    }),
);

export const vendorInquiriesReducer = [
    loadVendorInquirySummariesSuccess,
    generateVendorInquiriesSuccess,
    sendVendorInquiriesSuccess,
    selectVendorInquiriesForSending,
    updateVendorInquiryCCEmails,
    updateVendorInquiryMessage,
    updateVendorInquiryFileIds,
    clearVendorInquiry,
];
